import React, { FC } from "react";
import { BoxCard } from "ui/componentes";
import { LocalizationPTBr } from "util/MaterialTableUtil";
import MaterialTable from "material-table";
import { Championship, TeamStandings } from "api";
import {DateTime} from "luxon";
import { CsvBuilder } from "filefy";

interface TeamsStandingsTableProps {
    championship: Championship;
    teamsStandings: TeamStandings[];
}

const exportToCsv = (championship: Championship) => (
    columns,
    data
) => {
    const championshipName = championship.name.replace(/\s/g, "_").toLowerCase() || '';
    const fileName = `classificacao_equipes_${
        championshipName
    }_${DateTime.local().toFormat("dd-MM-yyyy-HH-mm-ss")}.csv`;

    const titleColumns = columns
        .filter((c) => c.export === undefined || c.export)
        .map((c) => c.title);

    const rows = data.map((team) => {
        const row: string[] = [];

        row.push(team.position);
        row.push(team.teamName);
        if (championship.isMultiClass) {
            row.push(team.className);
        }
        row.push(team.points);

        return row;
    });

    new CsvBuilder(fileName)
        .setDelimeter(";")
        .setColumns(titleColumns)
        .addRows(rows)
        .exportFile();
};

const TeamsStandingsTable: FC<TeamsStandingsTableProps> = ({
    teamsStandings,
    championship,
}) => {
    return (
        <MaterialTable
            components={{
                Container: BoxCard,
            }}
            title="Equipes"
            data={teamsStandings}
            columns={[
                {
                    field: "position",
                    title: "Pos.",
                    type: "numeric",
                    width: 50,
                    cellStyle: () => ({
                        padding: "6px 8px 6px 8px",
                    }),
                },
                {
                    field: "teamName",
                    title: "Equipe",
                    cellStyle: () => ({
                        padding: "6px 8px 6px 8px",
                    }),
                },
                {
                    field: "className",
                    title: "Classe",
                    hidden: !championship.isMultiClass,
                    export: championship.isMultiClass,
                    cellStyle: () => ({
                        padding: "6px 8px 6px 8px",
                    }),
                },
                {
                    field: "points",
                    title: "Pontuação",
                    type: "numeric",
                    cellStyle: () => ({
                        padding: "6px 8px 6px 8px",
                    }),
                },
            ]}
            options={{
                search: false,
                pageSize: 20,
                padding: "dense",
                headerStyle: { padding: "6px 8px 6px 8px" },
                exportDelimiter: ";",
                exportButton: true,
                exportCsv: exportToCsv(championship),
            }}
            localization={LocalizationPTBr}
        />
    );
};

export { TeamsStandingsTable };
